<template>
  <div id="expense_summary">
    <group-card title="Living Expenses" icon="attach_money" :tooltipText="tooltipText">
      <template v-slot:actions v-if="index > 0">
        <md-checkbox v-model="is_same_as_applicant" @change="copyFromApplicant1()">Same as applicant 1</md-checkbox>
      </template>
      <!-- <transition-group v-bind="transitions.expand"> -->
      <div class="boxed-category">
        <div class="md-layout content">
          <div class="md-layout-item md-size-100 data-column">
            <div class="property-list">
              <property-view name="Australian Citizen" class="width-325">
                {{ applicant.personal_details.residency }}
              </property-view>

              <property-view name="Marital Status" class="width-325">
                {{ applicant.personal_details.marital_status }}
              </property-view>

              <property-view name="Number of Dependants (Under 18)" class="width-325">
                {{ applicant.personal_details.number_of_dependants }}
              </property-view>
            </div>
          </div>
        </div>
      </div>

      <div class="boxed-category">
        <!-- Expense array inputs -->
        <div
          class="md-layout input-layout"
          v-for="(expense, index) in applicant.expenses"
          :key="id(expense)"
        >
          <!-- Type -->
          <validated-autocomplete-input
            class="md-layout-item md-small-size-100 md-size-20"
            label="Type"
            :prefixLabel="prefixLabel + ' ' + (index+1)"
            v-model="expense.type"
            :options="options.expense_type"
            required
            force
          />

          <!-- Amount -->
          <validated-number-input
            type="CURRENCY"
            class="md-layout-item md-small-size-100 md-size-20"
            label="Amount"
            :prefixLabel="prefixLabel + ' ' + (index+1)"
            prefix="$"
            v-model="expense.amount"
            :suffix="toMonthlyAmount(expense.amount, expense.frequency, true) + '/m'"
          />

          <!-- Frequency -->
          <validated-autocomplete-input
            class="md-layout-item md-small-size-100 md-size-20"
            label="Frequency"
            :prefixLabel="prefixLabel + ' ' + (index+1)"
            v-model="expense.frequency"
            :options="options.payment_frequency_options"
            force
          />

           <!-- Company Expenses -->
          <!-- BAUU-355 -Hide checbox until further update
          <div class="md-layout-item md-small-size-100 md-size-20">
            <md-checkbox v-model="expense.is_company_expenses">
              Company Expense?
            </md-checkbox>
          </div> -->

          <!-- remove button -->
          <div class="md-layout-item md-size-20 text-right">
            <md-button
              class="md-primary md-simple md-danger md-just-icon"
              @click="arrayRemove(applicant.expenses, expense)"
            >
              <md-icon>close</md-icon>
            </md-button
            >
          </div>
        </div>
      </div>

      <!-- </transition-group> -->

      <div class="md-layout">
        <!-- Add -->
        <div class="md-layout-item md-small-size-100 md-size-20">
          <md-button class="md-primary md-sm" @click="addListItem">Add</md-button>
        </div>
        <div class="md-layout-item md-small-size-100 md-size-20">
          Total: {{ totalMontlyExpense | currency }}
        </div>
      </div>
    </group-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import filters from "@/components/utils/filters";
import utils from "@/components/utils/utils";
import transitions from "@/components/utils/transitions";
import ValidatedInputs from "@/components/ValidatedInput";
import GroupCard from "@/components/Cards/GroupCard";
import GroupCardRow from "@/components/Cards/GroupCardRow";
import { newExpense } from "@/schema.js";
import { PropertyView } from "@/components";

export default {
  components: {
    ...ValidatedInputs,
    GroupCard,
    GroupCardRow,
    PropertyView,
  },
  data() {
    return {
      transitions,
      is_same_as_applicant: false,
      tooltipText: '<li>Married – Defacto – Collect full amount of expenses</li>'+
                    '<li>Boarding or living with friend – Only collect clients share of expenses</li>',
    };
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    prefixLabel: {
      type: String,
      default: "",
    },
    index: {
      type: [Number, String],
      default: 0,
    },
  },
  computed: {
    // standard list of options from store
    ...mapGetters({
      options: "options",
    }),

    // internal reference to the v-model on this component, handles incomeing and outgoing changes
    applicant: {
      get() {
        return this.value;
      },
      set(applicant) {
        this.$emit("input", applicant);
      },
    },

    totalMontlyExpense () {
         let total = 0;
         this.applicant.expenses.forEach(expense => {
            total = total + parseFloat(this.toMonthlyAmount(expense.amount, expense.frequency, false).toFixed(2))
         });
         return total
    }
  },
  methods: {
    // make all filters available as methods
    ...filters,
    ...utils,
    addListItem() {
      this.applicant.expenses.push(newExpense());
    },
    async copyFromApplicant1() {
      if (this.is_same_as_applicant) {
        await this.$store.dispatch('copyFromApplicant1', { type: 'living_expenses', applicant_index: this.index });
      }
    },
  },
  filters: {
    // make all filters available as filters
    ...filters,
  },
  async beforeCreate() {
    const params = {
      types: [
        'expense_type',
        'payment_frequency_options',
      ],
    }
    await this.$store.dispatch('fetch_types', { params });
  },
};
</script>
<style>
 .width-325 {
   width: 325px !important;
 }
</style>
